import {DeliveryProvider} from "../../../../../services/exports/Constants";

export default {
  text: {
    [DeliveryProvider.Standalone]: '<strong>Order on our site</strong> instead of other platforms for free food rewards, fastest service, and help us save <strong>{{savings}}</strong> on each order',
    [DeliveryProvider.FirstDelivery]: '<strong>Delivery & Pickup:</strong> Order on our site instead of other platforms for free food rewards, fastest service, and help us save <strong>{{savings}}</strong> on each order',
  },
};